import { StyleSheet } from 'react-native';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  logo: {
    marginVertical: pixelDimensions(10),
    height: pixelDimensions(20),
    width: pixelDimensions(20) * (75 / 22),
  },
  logo_2: {
    marginVertical: pixelDimensions(10),
    height: pixelDimensions(80) * (5 / 28),
    width: pixelDimensions(80),
  }
});

export { styles };
